import React, { PropTypes } from 'react';
import moment from 'moment';

const AuditSearchEntry = ({
  tournamentName,
  eventName,
  teamName,
  entryId,
  entryNumber,
  captainName,
  coordinatorName,
  isCancelled,
  bowlDateTime,
  tournamentTimeZone,
  showLink,
  onNavigationClick
}) => (
  <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child"
      style={{ width: 200 }}>
      <span>{'Tournament'}</span>
      <span>{`${tournamentName}`}</span>
    </div>
    {
      showLink ?
        <a className="list-group-item-labeled-child has-link"
          style={{ width: 120 }}
          onClick={() => onNavigationClick(`admin/audit/entry/${entryId}`)}>
          <span>{'Reservation Number'}</span>
          <span>{entryNumber || '-'}</span>
        </a>
        :
        <div className="list-group-item-labeled-child"
          style={{ width: 120 }} >
          <span>{'Reservation Number'}</span>
          <span>{entryNumber || '-'}</span>
        </div>
    }
    <div className="list-group-item-labeled-child"
      style={{ width: 125 }}>
      <span>{'Event'}</span>
      <span>{`${eventName}`}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{ width: 175 }}>
      <span>{'Team'}</span>
      <span>{teamName}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{ width: 210 }}>
      <span>{'Date'}</span>
      <span>
        {
          bowlDateTime
            ? `${moment.parseZone(bowlDateTime).format('MMM Do, YYYY, hh:mm:ss A')}
          (${tournamentTimeZone})`
            : isCancelled ? 'CANCELLED' : '-'
        }
      </span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{ width: 250 }}>
      <span>{'Captain'}</span>
      <span>{captainName}</span>
    </div>
    {
      <div className="list-group-item-labeled-child"
        style={{ width: 210 }}>
        <span>{coordinatorName && coordinatorName.trim().length > 0 ? 'Coordinator' : 'No coordinator'}</span>
        <span>{coordinatorName}</span>
      </div>
    }
  </div>
);

AuditSearchEntry.propTypes = {
  addressBase: PropTypes.string,
  eventName: PropTypes.string,
  teamName: PropTypes.string,
  entryNumber: PropTypes.string,
  bowlDateTime: PropTypes.string,
  tournamentTimeZone: PropTypes.string,
  entryId: PropTypes.string,
  tournamentId: PropTypes.string,
  tournamentName: PropTypes.string,
  captainName: PropTypes.string,
  coordinatorName: PropTypes.string,
  isCancelled: PropTypes.bool,
  showLink: PropTypes.bool,
  onNavigationClick: PropTypes.func
};

AuditSearchEntry.defaultProps = {
  showLink: true
};

export default AuditSearchEntry;



// WEBPACK FOOTER //
// ./src/features/admin/audit/entryAudit/AuditSearchEntry.jsx